import React, { memo, useMemo } from 'react';

import { Fab, Tooltip } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { addButtonStyle } from 'constants/layout';

const AddButton = ({
  dataTestId = '',
  icon: IconComponent,
  iconSize,
  styleConfig = 'default',
  ariaLabel = 'add',
  disabled = false,
  className,
  PopperProps,
  disablePortal = false,
  sx,
  ...restProps
}) => {
  const addButtonSx = useMemo(
    () => ({ ...addButtonStyle[styleConfig], ...sx, zIndex: 200 }),
    [styleConfig, sx],
  );
  const poppperProps = useMemo(
    () => ({ disablePortal, ...PopperProps }),
    [PopperProps, disablePortal],
  );

  return (
    <Tooltip PopperProps={poppperProps} title={ariaLabel}>
      <Fab
        aria-label={ariaLabel}
        className={clsx(className, 'shrink-0')}
        color="secondary"
        component={disabled ? 'span' : undefined}
        data-testid={dataTestId}
        disabled={disabled}
        sx={addButtonSx}
        {...restProps}
      >
        <IconComponent size={iconSize} />
      </Fab>
    </Tooltip>
  );
};

AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  dataTestId: PropTypes.string,
  styleConfig: PropTypes.string,
  size: PropTypes.string,
  ariaLabel: PropTypes.string,
  icon: PropTypes.elementType,
  iconSize: PropTypes.number,
  disabled: PropTypes.bool,
  PopperProps: PropTypes.object,
  disablePortal: PropTypes.bool,
  sx: PropTypes.object,
};

export default memo(AddButton);
